// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1-XKA","footer-container":"Footer_footer-container__16cCk","footer__arrow-up":"Footer_footer__arrow-up__1BGDG","footer__copy":"Footer_footer__copy__2QCn3"};